import React from "react";
import { FiEdit } from "react-icons/fi";

import BirthDate from "components/MI/alteracao-cadastral/BirthDate";
import BirthDateAUC from "components/MI/alteracao-cadastral/BirthDateAUC";
import EditPhone from "components/MI/alteracao-cadastral/EditPhone";
import EditRegisterEmail from "components/MI/alteracao-cadastral/EditRegisterEmail";
import EmailConfirm from "components/MI/alteracao-cadastral/EmailConfirm";
import Loading from "components/layout/loading";
import NameSocial from "components/MI/alteracao-cadastral/NameSocial";
import Navbar from "components/MI/Navbar";
import TokenPhone from "components/MI/alteracao-cadastral/TokenPhone";
import UserMenu from "components/layout/userMenuNew";

import { useMeusDadosPage } from "../hooks/useMeusDadosPage";
import {
  Action,
  Badge,
  Body,
  Container,
  ContainerDownload,
  Download,
  Header,
  HeaderInfos,
  HeaderSubtitle,
  HeaderTitle,
  Info,
  InfoContent,
  Label,
  PanelContainer,
} from "../styles";

const MeusDadosPage = (): JSX.Element => {
  const {
    loading,
    userInfo,
    setUserInfo,
    emailAwait,
    setEmailAwait,
    phoneAwait,
    setPhoneAwait,
    openAUCModal,
    setOpenAUCModal,
    openNameSocialModal,
    setOpenNameSocialModal,
    openBirthDateModal,
    setOpenBirthDateModal,
    openEditEmailModal,
    setOpenEditEmailModal,
    openEditPhoneModal,
    setOpenEditPhoneModal,
    openEmailConfirmModal,
    setOpenEmailConfirmModal,
    openTokenPhoneModal,
    setOpenTokenPhoneModal,
    birthDate,
    phoneNumber,
    hasEmailCheck,
    selectedUnit,
  } = useMeusDadosPage();

  return (
    <>
      <Navbar selected="meus-dados">
        <UserMenu />
        <Container>
          <Header>
            <HeaderInfos>
              <HeaderTitle>Meus dados</HeaderTitle>
              <HeaderSubtitle>Verifique seus dados.</HeaderSubtitle>
            </HeaderInfos>
          </Header>
          <Body>
            <PanelContainer>
              <InfoContent>
                {selectedUnit.hasCurrentHouseholder ? (
                  <Action onClick={() => setOpenNameSocialModal(true)}>
                    <FiEdit />
                  </Action>
                ) : null}
              </InfoContent>

              <InfoContent>
                <div>
                  <Label as="div">Data de nascimento</Label>
                  <Info>{birthDate}</Info>
                </div>
                {selectedUnit.hasCurrentHouseholder ? (
                  <Action onClick={() => setOpenBirthDateModal(true)}>
                    <FiEdit />
                  </Action>
                ) : null}
              </InfoContent>

              <InfoContent>
                <div>
                  <Label as="div">E-mail</Label>
                  <Info>{userInfo && userInfo.email}</Info>
                  {(!userInfo || !userInfo.email) && hasEmailCheck && (
                    <Badge>Por favor, valide seu e-mail</Badge>
                  )}
                </div>
                {selectedUnit.hasCurrentHouseholder ? (
                  <Action onClick={() => setOpenEditEmailModal(true)}>
                    <FiEdit />
                  </Action>
                ) : null}
              </InfoContent>

              <InfoContent>
                <div>
                  <Label as="div">Celular</Label>
                  <Info>{phoneNumber}</Info>
                </div>
                {selectedUnit.hasCurrentHouseholder ? (
                  <Action onClick={() => setOpenEditPhoneModal(true)}>
                    <FiEdit />
                  </Action>
                ) : null}
              </InfoContent>

              <ContainerDownload>
                Você pode acessar o termo de adesão
                <Download href="/static/TermoDeAdesaoMI.pdf" target="_blank">
                  clicando aqui.
                </Download>
              </ContainerDownload>
            </PanelContainer>
          </Body>
        </Container>
      </Navbar>
      <NameSocial
        openModal={openNameSocialModal}
        modalFunction={setOpenNameSocialModal}
        userInfo={userInfo}
        setUserInfo={setUserInfo}
      />
      <BirthDate
        openModal={openBirthDateModal}
        modalFunction={setOpenBirthDateModal}
        userInfo={userInfo}
        setUserInfo={setUserInfo}
        setOpenAUCModal={setOpenAUCModal}
      />
      <BirthDateAUC openModal={openAUCModal} modalFunction={setOpenAUCModal} />
      <EditRegisterEmail
        openModal={openEditEmailModal}
        modalFunction={setOpenEditEmailModal}
        userInfo={userInfo}
        setEmailAwait={setEmailAwait}
        setOpenEmailConfirmModal={setOpenEmailConfirmModal}
      />
      <EmailConfirm
        openModal={openEmailConfirmModal}
        modalFunction={setOpenEmailConfirmModal}
        userInfo={userInfo}
        email={emailAwait}
      />
      <EditPhone
        openModal={openEditPhoneModal}
        modalFunction={setOpenEditPhoneModal}
        userInfo={userInfo}
        setPhoneAwait={setPhoneAwait}
        setOpenTokenPhoneModal={setOpenTokenPhoneModal}
      />
      <TokenPhone
        openModal={openTokenPhoneModal}
        modalFunction={setOpenTokenPhoneModal}
        userInfo={userInfo}
        setUserInfo={setUserInfo}
        phoneAwait={phoneAwait}
      />
      {loading && <Loading />}
    </>
  );
};

export default MeusDadosPage;
